import axios from 'axios';

const API_BASE = '/api';;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  googleCallback: (session_id) => api.post('/auth/google/callback', { session_id }),
  getMe: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
};

// Categories API
export const categoriesAPI = {
  getAll: () => api.get('/categories'),
};

// Accounts API
export const accountsAPI = {
  getAll: (params) => api.get('/accounts', { params }),
  getById: (id) => api.get(`/accounts/${id}`),
  search: (q, category) => api.get('/accounts/search', { params: { q, category } }),
};

// Cart API
export const cartAPI = {
  get: () => api.get('/cart'),
  add: (data) => api.post('/cart/add', data),
  remove: (id) => api.delete(`/cart/${id}`),
  clear: () => api.delete('/cart'),
};

// Orders API
export const ordersAPI = {
  create: (data) => api.post('/orders/create', data),
  verify: (data) => api.post('/orders/verify', data),
  getAll: () => api.get('/orders'),
  getById: (id) => api.get(`/orders/${id}`),
  checkStatus: (id) => api.get(`/orders/${id}/status`),
};

// Reviews API
export const reviewsAPI = {
  create: (data) => api.post('/reviews', data),
  getByAccount: (accountId) => api.get(`/reviews/${accountId}`),
  getStats: (accountId) => api.get(`/reviews/${accountId}/stats`),
};

// Coupons API
export const couponsAPI = {
  apply: (data) => api.post('/coupons/apply', data),
};

// Profile API
export const profileAPI = {
  get: () => api.get('/profile'),
  update: (data) => api.put('/profile', data),
  getTransactions: () => api.get('/profile/transactions'),
};

// Notifications API
export const notificationsAPI = {
  getAll: () => api.get('/notifications'),
  getUnreadCount: () => api.get('/notifications/unread-count'),
  markAsRead: (id) => api.put(`/notifications/${id}/read`),
  markAllAsRead: () => api.put('/notifications/read-all'),
};

// Stock Alerts API
export const stockAlertsAPI = {
  create: (account_id) => api.post('/stock-alerts', { account_id }),
  getAll: () => api.get('/stock-alerts'),
  delete: (id) => api.delete(`/stock-alerts/${id}`),
};

// Admin API
export const adminAPI = {
  // Accounts
  createAccount: (data) => api.post('/admin/accounts', data),
  updateAccount: (id, data) => api.put(`/admin/accounts/${id}`, data),
  deleteAccount: (id) => api.delete(`/admin/accounts/${id}`),
  triggerStockAlerts: (id) => api.post(`/admin/trigger-stock-alerts/${id}`),
  
  // Categories
  createCategory: (data) => api.post('/admin/categories', data),
  updateCategory: (id, data) => api.put(`/admin/categories/${id}`, data),
  deleteCategory: (id) => api.delete(`/admin/categories/${id}`),
  
  // Orders
  getAllOrders: () => api.get('/admin/orders'),
  
  // Customers
  getCustomers: () => api.get('/admin/customers'),
  
  // Analytics
  getAnalytics: () => api.get('/admin/analytics'),
  
  // Admin Management
  createAdmin: (data) => api.post('/admin/create-admin', data),
  getAllAdmins: () => api.get('/admin/admins'),
  
  // Coupons
  createCoupon: (data) => api.post('/admin/coupons', data),
  getAllCoupons: () => api.get('/admin/coupons'),
  deleteCoupon: (id) => api.delete(`/admin/coupons/${id}`),
  
  // User Tracking
  createTracking: (data) => api.post('/admin/tracking', data),
  getAllTracking: () => api.get('/admin/tracking'),
  searchTracking: (q) => api.get('/admin/tracking/search', { params: { q } }),
  updateTracking: (id, data) => api.put(`/admin/tracking/${id}`, data),
  deleteTracking: (id) => api.delete(`/admin/tracking/${id}`),
};

// Upload API
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default api;
